<div class="card social-profile">
  <div class="card-body">
    <div class="social-img-wrap">
      <div class="social-img"><img src="assets/images/dashboard-5/profile.png" alt="profile" /></div>
      <div class="edit-icon">
        <svg>
          <use href="assets/svg/icon-sprite.svg#profile-check"></use>
        </svg>
      </div>
    </div>
    <div class="social-details">
      <h5 class="mb-1"><a href="social-app.html">{{ 'Brooklyn Simmons' | translate }}</a></h5>
      <span class="f-light">{{ '&#64;brookly.simmons' | translate }}</span>
      <ul class="social-follow">
        <li>
          <h5 class="mb-0">{{ '1,908' | translate }}</h5>
          <span class="f-light">{{ 'Posts' | translate }}</span>
        </li>
        <li>
          <h5 class="mb-0">{{ '34.0k' | translate }}</h5>
          <span class="f-light">{{ 'Followers' | translate }}</span>
        </li>
        <li>
          <h5 class="mb-0">{{ '897' | translate }}</h5>
          <span class="f-light">{{ 'Following' | translate }}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
